import * as types from '../actionsTypes/profiliOrariActionType';
import new_axios_instance from '../../axios_instance';
import {loadingOverlayActions, notifsActions} from "../index";
import {createMessageRequestException} from "../../fanctionUtility";
import {TIPO_CORSO, TIPO_RECUPERO_PROFILO_ORARIO} from "../../costanti";

export const initProfiliOrari = () => {
    return {
        type: types.INIT_PROFILI_ORARI
    }
};

export const initProfiliOrariResponse = () => {
    return {
        type: types.INIT_PROFILI_ORARI_RESPONSE
    }
};
/***************** Action utilizzata per recuperare i Profili Orari di tutti gli individui per la tabella ProfiliSCR -> riepilogo e ProfiliFSE -> index ************************/

export const startRecuperoProfiliOrariIndividuo = (param) => async dispatch => {
    await new_axios_instance.get(`/v1/profiloorario/ricerca/corso/${param.idCorso}/idAnagrafica/${param.idAnagrafica}`)
        .then(response => {
            switch (param.tipo) {
                case TIPO_RECUPERO_PROFILO_ORARIO.RIEPILOGO_INDIVIDUI : {
                    // let mapProfiliIndividuo = new Map();
                    // mapProfiliIndividuo = mapProfiliIndividuo.set(param.idAnagrafica, response.data);
                    dispatch(getProfiliOrariSuccess({idAnagrafica: param.idAnagrafica, profiliOrari: response.data}));
                    break;
                }

                case TIPO_RECUPERO_PROFILO_ORARIO.SINGOLO_INDIVIDUO : {
                    dispatch(getRecuperoProfiliOrariSingoloIndiviuoSuccess(response.data));
                    break;
                }

                default :
                    break;
            }

        }).catch(error => {
                switch (param.tipo) {

                    case TIPO_RECUPERO_PROFILO_ORARIO.RIEPILOGO_INDIVIDUI : {
                        const messaggio = (error.response.data) ?
                            (typeof (error.response.data) === 'string') ?
                                Array.of(error.response.data) :
                                (Object.keys(error.response.data).map(key => key.toString() + ': ' + ''.concat(error.response.data[key].join(', ')))) :
                            Array.of(error.message);
                        //let mapError = new Map();
                        //mapError = mapError.set(param.idAnagrafica, messaggio);
                        dispatch(getProfiliOrariFail({idAnagrafica: param.idAnagrafica, errorMessage: messaggio}));
                        break;
                    }

                    case TIPO_RECUPERO_PROFILO_ORARIO.SINGOLO_INDIVIDUO : {
                        const message = createMessageRequestException(error);
                        dispatch(notifsActions.notifError(message));
                        window.scrollTo({top: 0, behavior: "smooth"});
                        document.getElementsByTagName('main')[0].scrollTo({top: 0, behavior: "smooth"});
                        break;
                    }
                    default :
                        break;
                }

            }
        );
};

const getProfiliOrariSuccess = (response) => {
    return {
        type: types.GET_RECUPERO_PROFILI_ORARI_SUCCESS,
        profiloOrario: response
    }
};

const getProfiliOrariFail = (error) => {
    return {
        type: types.GET_RECUPERO_PROFILI_ORARI_FAIL,
        error: error
    }
};

const getRecuperoProfiliOrariSingoloIndiviuoSuccess = (responseProfiliOrari) => {
    return {
        type: types.GET_PROFILO_ORARIO_SINGOLO_INDIVIDUO_SUCCESS,
        profiliOrari: responseProfiliOrari
    }
};

/***************** Recupero Profili Orari di tutti gli individui ************************/

/*************************** Action Inserimento Profilo Orario  ***********************/

export const addProfiloOrarioStart = (request, navigate, tipo) => async dispatch => {
    dispatch(loadingOverlayActions.showLoadingOverlay());
    await new_axios_instance.post('/v1/profiloorario/inserisci', request)
        .then(response => {
            dispatch(loadingOverlayActions.hideLoadingOverlay());
            dispatch(notifsActions.notifSuccess('Inserimento del nuovo profilo orario avvenuto con successo'));
            dispatch(addProfiloOrarioSuccess(response.data));
            navigate(tipo === TIPO_CORSO.FORMAZIONE || TIPO_CORSO.GARANZIA_GIOVANI || TIPO_CORSO.COFO ? `/corso/${request.idCorso}/profiliorariFSE` : `/corso/${request.idCorso}/profiliorariSCR`);
        }).catch(error => {
            const messaggio = (error.response.data) ?
                (typeof (error.response.data) === 'string') ?
                    Array.of(error.response.data) :
                    (Object.keys(error.response.data).map(key => key.toString() + ': ' + ''.concat(error.response.data[key].join(', ')))) :
                Array.of(error.message);
            dispatch(notifsActions.notifError(messaggio));
            dispatch(addProfiloOrarioFail());
            dispatch(loadingOverlayActions.hideLoadingOverlay());

            window.scrollTo({top: 0, behavior: "smooth"});
            document.getElementsByTagName('main')[0].scrollTo({top: 0, behavior: "smooth"})
        })
};

const addProfiloOrarioSuccess = (response) => {
    return {
        type: types.ADD_PROFILO_ORARIO_SUCCESS,
        profiliOrariResponse: response
    }
};

const addProfiloOrarioFail = () => {
    return {
        type: types.ADD_PROFILO_ORARIO_FAIL
    }
};

/*************************** Action Inserimento Profilo Orario  ***********************/


